var Chartist = require("chartist");
var $ = require("jquery");

function commafy(num) {
  num = num.toString();
  if (!num) return;
  if (num.length >= 4) {
    num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  return num;
}

var data2 = {
  labels: ["'48", "'50", "'51", "'52", "'53", "'54", "'55", "'56", "'57", "'58", "'59", "'60", "'61", "'62", "'63", "'64", "'65", "'66", "'67", "'68", "'69", "'70", "'71", "'72", "'73", "'74", "'75", "'76", "'77", "'78", "'79", "'80", "'81", "'82", "'83", "'84", "'85", "'86", "'87", "'88", "'89", "'90", "'91", "'92", "'93", "'94", "'95", "'96", "'97", "'98", "'99", "'00", "'01", "'02", "'03", "'04", "'05", "'06", "'07", "'08", "'09", "'10", "'11", "'12", "'13", "'14"],
  series: [{
    name: 'Property',
    data: [{
      meta: "1948", value: 0.043}, {
      meta: "1950", value: 0.056}, {
      meta: "1951", value: 0.063}, {
      meta: "1952", value: 0.061}, {
      meta: "1953", value: 0.062}, {
      meta: "1954", value: 0.068}, {
      meta: "1955", value: 0.068}, {
      meta: "1956", value: 0.064}, {
      meta: "1957", value: 0.065}, {
      meta: "1958", value: 0.067}, {
      meta: "1959", value: 0.065}, {
      meta: "1960", value: 0.074}, {
      meta: "1961", value: 0.071}, {
      meta: "1962", value: 0.069}, {
      meta: "1963", value: 0.072}, {
      meta: "1964", value: 0.075}, {
      meta: "1965", value: 0.077}, {
      meta: "1966", value: 0.075}, {
      meta: "1967", value: 0.076}, {
      meta: "1968", value: 0.095}, {
      meta: "1969", value: 0.107}, {
      meta: "1970", value: 0.11}, {
      meta: "1971", value: 0.103}, {
      meta: "1972", value: 0.113}, {
      meta: "1973", value: 0.102}, {
      meta: "1974", value: 0.067}, {
      meta: "1975", value: 0.101}, {
      meta: "1976", value: 0.147}, {
      meta: "1977", value: 0.144}, {
      meta: "1978", value: 0.143}, {
      meta: "1979", value: 0.156}, {
      meta: "1980", value: 0.162}, {
      meta: "1981", value: 0.168}, {
      meta: "1982", value: 0.175}, {
      meta: "1983", value: 0.165}, {
      meta: "1984", value: 0.152}, {
      meta: "1985", value: 0.159}, {
      meta: "1986", value: 0.157}, {
      meta: "1987", value: 0.158}, {
      meta: "1988", value: 0.158}, {
      meta: "1989", value: 0.155}, {
      meta: "1990", value: 0.149}, {
      meta: "1991", value: 0.155}, {
      meta: "1992", value: 0.164}, {
      meta: "1993", value: 0.168}, {
      meta: "1994", value: 0.165}, {
      meta: "1995", value: 0.165}, {
      meta: "1996", value: 0.17}, {
      meta: "1997", value: 0.172}, {
      meta: "1998", value: 0.173}, {
      meta: "1999", value: 0.175}, {
      meta: "2000", value: 0.135}, {
      meta: "2001", value: 0.11}, {
      meta: "2002", value: 0.115}, {
      meta: "2003", value: 0.116}, {
      meta: "2004", value: 0.11}, {
      meta: "2005", value: 0.107}, {
      meta: "2006", value: 0.099}, {
      meta: "2007", value: 0.095}, {
      meta: "2008", value: 0.097}, {
      meta: "2009", value: 0.109}, {
      meta: "2010", value: 0.113}, {
      meta: "2011", value: 0.107}, {
      meta: "2012", value: 0.108}, {
      meta: "2013", value: 0.103}, {
      meta: "2014", value: 0.102}],
  }, {
    name: "Sales",
    data: [  {meta: "1948", value: 0.862	}, 	 {
          meta: "1950", value: 0.824	}, 	 {
          meta: "1951", value: 0.828	}, 	 {
          meta: "1952", value: 0.836	}, 	 {
          meta: "1953", value: 0.833	}, 	 {
          meta: "1954", value: 0.813	}, 	 {
          meta: "1955", value: 0.823	}, 	 {
          meta: "1956", value: 0.834	}, 	 {
          meta: "1957", value: 0.831	}, 	 {
          meta: "1958", value: 0.82	}, 	 {
          meta: "1959", value: 0.823	}, 	 {
          meta: "1960", value: 0.822	}, 	 {
          meta: "1961", value: 0.823	}, 	 {
          meta: "1962", value: 0.829	}, 	 {
          meta: "1963", value: 0.821	}, 	 {
          meta: "1964", value: 0.816	}, 	 {
          meta: "1965", value: 0.812	}, 	 {
          meta: "1966", value: 0.816	}, 	 {
          meta: "1967", value: 0.818	}, 	 {
          meta: "1968", value: 0.81	}, 	 {
          meta: "1969", value: 0.803	}, 	 {
          meta: "1970", value: 0.792	}, 	 {
          meta: "1971", value: 0.802	}, 	 {
          meta: "1972", value: 0.79	}, 	 {
          meta: "1973", value: 0.796	}, 	 {
          meta: "1974", value: 0.83	}, 	 {
          meta: "1975", value: 0.793	}, 	 {
          meta: "1976", value: 0.749	}, 	 {
          meta: "1977", value: 0.757	}, 	 {
          meta: "1978", value: 0.765	}, 	 {
          meta: "1979", value: 0.754	}, 	 {
          meta: "1980", value: 0.746	}, 	 {
          meta: "1981", value: 0.741	}, 	 {
          meta: "1982", value: 0.721	}, 	 {
          meta: "1983", value: 0.744	}, 	 {
          meta: "1984", value: 0.762	}, 	 {
          meta: "1985", value: 0.752	}, 	 {
          meta: "1986", value: 0.76	}, 	 {
          meta: "1987", value: 0.753	}, 	 {
          meta: "1988", value: 0.753	}, 	 {
          meta: "1989", value: 0.752	}, 	 {
          meta: "1990", value: 0.75	}, 	 {
          meta: "1991", value: 0.75	}, 	 {
          meta: "1992", value: 0.749	}, 	 {
          meta: "1993", value: 0.746	}, 	 {
          meta: "1994", value: 0.747	}, 	 {
          meta: "1995", value: 0.749	}, 	 {
          meta: "1996", value: 0.743	}, 	 {
          meta: "1997", value: 0.74	}, 	 {
          meta: "1998", value: 0.735	}, 	 {
          meta: "1999", value: 0.734	}, 	 {
          meta: "2000", value: 0.771	}, 	 {
          meta: "2001", value: 0.793	}, 	 {
          meta: "2002", value: 0.788	}, 	 {
          meta: "2003", value: 0.78	}, 	 {
          meta: "2004", value: 0.782	}, 	 {
          meta: "2005", value: 0.785	}, 	 {
          meta: "2006", value: 0.786	}, 	 {
          meta: "2007", value: 0.782	}, 	 {
          meta: "2008", value: 0.802	}, 	 {
          meta: "2009", value: 0.799	}, 	 {
          meta: "2010", value: 0.798	}, 	 {
          meta: "2011", value: 0.81	}, 	 {
          meta: "2012", value: 0.804	}, 	 {
          meta: "2013", value: 0.783	}, 	 {
          meta: "2014", value: 0.782	}],
  }, {
    name: "License",
    data: [{meta: "1948", value:	0.076	}, 	 {
          meta: "1950", value:	0.1	}, 	 {
          meta: "1951", value:	0.093	}, 	 {
          meta: "1952", value:	0.087	}, 	 {
          meta: "1953", value:	0.087	}, 	 {
          meta: "1954", value:	0.094	}, 	 {
          meta: "1955", value:	0.089	}, 	 {
          meta: "1956", value:	0.084	}, 	 {
          meta: "1957", value:	0.083	}, 	 {
          meta: "1958", value:	0.085	}, 	 {
          meta: "1959", value:	0.088	}, 	 {
          meta: "1960", value:	0.082	}, 	 {
          meta: "1961", value:	0.083	}, 	 {
          meta: "1962", value:	0.08	}, 	 {
          meta: "1963", value:	0.08	}, 	 {
          meta: "1964", value:	0.084	}, 	 {
          meta: "1965", value:	0.082	}, 	 {
          meta: "1966", value:	0.079	}, 	 {
          meta: "1967", value:	0.077	}, 	 {
          meta: "1968", value:	0.069	}, 	 {
          meta: "1969", value:	0.066	}, 	 {
          meta: "1970", value:	0.072	}, 	 {
          meta: "1971", value:	0.071	}, 	 {
          meta: "1972", value:	0.07	}, 	 {
          meta: "1973", value:	0.07	}, 	 {
          meta: "1974", value:	0.071	}, 	 {
          meta: "1975", value:	0.067	}, 	 {
          meta: "1976", value:	0.062	}, 	 {
          meta: "1977", value:	0.057	}, 	 {
          meta: "1978", value:	0.057	}, 	 {
          meta: "1979", value:	0.055	}, 	 {
          meta: "1980", value:	0.054	}, 	 {
          meta: "1981", value:	0.054	}, 	 {
          meta: "1982", value:	0.056	}, 	 {
          meta: "1983", value:	0.056	}, 	 {
          meta: "1984", value:	0.052	}, 	 {
          meta: "1985", value:	0.054	}, 	 {
          meta: "1986", value:	0.051	}, 	 {
          meta: "1987", value:	0.052	}, 	 {
          meta: "1988", value:	0.055	}, 	 {
          meta: "1989", value:	0.054	}, 	 {
          meta: "1990", value:	0.053	}, 	 {
          meta: "1991", value:	0.054	}, 	 {
          meta: "1992", value:	0.051	}, 	 {
          meta: "1993", value:	0.049	}, 	 {
          meta: "1994", value:	0.047	}, 	 {
          meta: "1995", value:	0.047	}, 	 {
          meta: "1996", value:	0.047	}, 	 {
          meta: "1997", value:	0.045	}, 	 {
          meta: "1998", value:	0.045	}, 	 {
          meta: "1999", value:	0.046	}, 	 {
          meta: "2000", value:	0.048	}, 	 {
          meta: "2001", value:	0.049	}, 	 {
          meta: "2002", value:	0.05	}, 	 {
          meta: "2003", value:	0.052	}, 	 {
          meta: "2004", value:	0.049	}, 	 {
          meta: "2005", value:	0.049	}, 	 {
          meta: "2006", value:	0.049	}, 	 {
          meta: "2007", value:	0.051	}, 	 {
          meta: "2008", value:	0.053	}, 	 {
          meta: "2009", value:	0.057	}, 	 {
          meta: "2010", value:	0.058	}, 	 {
          meta: "2011", value:	0.053	}, 	 {
          meta: "2012", value:	0.056	}, 	 {
          meta: "2013", value:	0.075	}, 	 {
          meta: "2014", value:	0.073	}]
  },
  {
    name: "Other",
    data: [{meta: "1948", value:	0.019	}, 	 {
          meta: "1950", value:	0.02	}, 	 {
          meta: "1951", value:	0.016	}, 	 {
          meta: "1952", value:	0.016	}, 	 {
          meta: "1953", value:	0.018	}, 	 {
          meta: "1954", value:	0.025	}, 	 {
          meta: "1955", value:	0.02	}, 	 {
          meta: "1956", value:	0.018	}, 	 {
          meta: "1957", value:	0.021	}, 	 {
          meta: "1958", value:	0.028	}, 	 {
          meta: "1959", value:	0.024	}, 	 {
          meta: "1960", value:	0.022	}, 	 {
          meta: "1961", value:	0.023	}, 	 {
          meta: "1962", value:	0.021	}, 	 {
          meta: "1963", value:	0.028	}, 	 {
          meta: "1964", value:	0.025	}, 	 {
          meta: "1965", value:	0.029	}, 	 {
          meta: "1966", value:	0.03	}, 	 {
          meta: "1967", value:	0.029	}, 	 {
          meta: "1968", value:	0.027	}, 	 {
          meta: "1969", value:	0.024	}, 	 {
          meta: "1970", value:	0.026	}, 	 {
          meta: "1971", value:	0.023	}, 	 {
          meta: "1972", value:	0.027	}, 	 {
          meta: "1973", value:	0.031	}, 	 {
          meta: "1974", value:	0.031	}, 	 {
          meta: "1975", value:	0.039	}, 	 {
          meta: "1976", value:	0.042	}, 	 {
          meta: "1977", value:	0.042	}, 	 {
          meta: "1978", value:	0.035	}, 	 {
          meta: "1979", value:	0.035	}, 	 {
          meta: "1980", value:	0.038	}, 	 {
          meta: "1981", value:	0.037	}, 	 {
          meta: "1982", value:	0.047	}, 	 {
          meta: "1983", value:	0.036	}, 	 {
          meta: "1984", value:	0.034	}, 	 {
          meta: "1985", value:	0.035	}, 	 {
          meta: "1986", value:	0.032	}, 	 {
          meta: "1987", value:	0.037	}, 	 {
          meta: "1988", value:	0.034	}, 	 {
          meta: "1989", value:	0.039	}, 	 {
          meta: "1990", value:	0.049	}, 	 {
          meta: "1991", value:	0.041	}, 	 {
          meta: "1992", value:	0.037	}, 	 {
          meta: "1993", value:	0.037	}, 	 {
          meta: "1994", value:	0.041	}, 	 {
          meta: "1995", value:	0.038	}, 	 {
          meta: "1996", value:	0.04	}, 	 {
          meta: "1997", value:	0.043	}, 	 {
          meta: "1998", value:	0.046	}, 	 {
          meta: "1999", value:	0.045	}, 	 {
          meta: "2000", value:	0.046	}, 	 {
          meta: "2001", value:	0.047	}, 	 {
          meta: "2002", value:	0.047	}, 	 {
          meta: "2003", value:	0.053	}, 	 {
          meta: "2004", value:	0.059	}, 	 {
          meta: "2005", value:	0.059	}, 	 {
          meta: "2006", value:	0.065	}, 	 {
          meta: "2007", value:	0.072	}, 	 {
          meta: "2008", value:	0.048	}, 	 {
          meta: "2009", value:	0.036	}, 	 {
          meta: "2010", value:	0.031	}, 	 {
          meta: "2011", value:	0.03	}, 	 {
          meta: "2012", value:	0.032	}, 	 {
          meta: "2013", value:	0.038	}, 	 {
          meta: "2014", value:	0.044	}]
  }]
};


var options2 = {
  showPoint: true,
  lineSmooth: false,
  axisX: {
    // We can disable the grid for this axis
    showGrid: false,
    showLabel: true,
    labelInterpolationFnc: function(value, index) {
        return index % 5 === 0 ? value : null;
      },
      labelOffset: {
        x: -10,
        y: 0
      }
  },

  axisY: {
    labelOffset: {
      x: -6,
      y: 6
    },
    labelInterpolationFnc: function(value) {
      return (value * 100) + '%';
    }
  }
};

// All you need to do is pass your configuration as third parameter to the chart function
new Chartist.Line('#chart2', data2, options2);

var $chart2 = $('#chart2');

var $toolTip2 = $chart2
  .append('<div class="tooltip"></div>')
  .find('.tooltip')
  .hide();

$chart2.on('mouseenter', '.ct-point', function() {
  var $bar = $(this),
    value = $bar.attr('ct:value'),
    seriesName = $bar.parent().attr('ct:series-name');
  var meta = ($bar.attr('ct:meta'));


  $toolTip2.html('<span class="popuptitle">' + seriesName + '</span><br><div class="popuptext">' + meta + ': ' + (value * 100).toFixed(1) + '%</div>').show();
});

$chart2.on('mouseleave', '.ct-point', function() {
  $toolTip2.hide();
});

$chart2.on('mousemove', function(event) {
  $toolTip2.css({
    left: (event.offsetX || event.originalEvent.layerX) - $toolTip2.width() / 2 - 30,
    top: (event.offsetY || event.originalEvent.layerY) - $toolTip2.height() - 30
  });
});
